import React from 'react';
import { format } from 'date-fns';
import { Dialog } from '@mui/material';
import './styles/MeetingRescheduleConfirmDialog.css';

const MeetingRescheduleConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  currentStartDate,
  nextStartDate,
  reason = '',
  submitting = false,
}) => {
  const trimmedReason = String(reason || '').trim();

  return (
    <Dialog
      open={open}
      onClose={submitting ? undefined : onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ className: 'meeting-reschedule-confirm__paper' }}
    >
      <div className="meeting-reschedule-confirm">
        <div className="meeting-reschedule-confirm__body">
          <div className="meeting-reschedule-confirm__header">
            <h2 className="meeting-reschedule-confirm__title">Save this meeting change?</h2>
            <button
              type="button"
              className="meeting-reschedule-confirm__close"
              onClick={onClose}
              disabled={submitting}
              aria-label="Close confirmation dialog"
            >
              ×
            </button>
          </div>
          <div className="meeting-reschedule-confirm__subheader">
            <p className="meeting-reschedule-confirm__subtitle">
              Review the updated meeting time before saving.
            </p>
          </div>

          <div className="meeting-reschedule-confirm__summary">
            <div className="meeting-reschedule-confirm__summary-card">
              <span className="meeting-reschedule-confirm__label">Current</span>
              <p className="meeting-reschedule-confirm__value">
                {currentStartDate ? format(currentStartDate, 'MMM d, yyyy, h:mm a') : 'N/A'}
              </p>
            </div>
            <div className="meeting-reschedule-confirm__summary-card meeting-reschedule-confirm__summary-card--next">
              <span className="meeting-reschedule-confirm__label">New</span>
              <p className="meeting-reschedule-confirm__value">
                {nextStartDate ? format(nextStartDate, 'MMM d, yyyy, h:mm a') : 'N/A'}
              </p>
            </div>
          </div>

          {trimmedReason && (
            <div className="meeting-reschedule-confirm__reason">
              <span className="meeting-reschedule-confirm__label">Reason</span>
              <p className="meeting-reschedule-confirm__reason-text">{trimmedReason}</p>
            </div>
          )}
        </div>

        <div className="meeting-reschedule-confirm__actions">
          <button
            type="button"
            className="meeting-reschedule-confirm__button meeting-reschedule-confirm__button--secondary"
            onClick={onClose}
            disabled={submitting}
          >
            Back
          </button>
          <button
            type="button"
            className="meeting-reschedule-confirm__button meeting-reschedule-confirm__button--primary"
            onClick={onConfirm}
            disabled={submitting}
          >
            {submitting ? 'Saving...' : 'Confirm reschedule'}
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default MeetingRescheduleConfirmDialog;
